<div class="container">
  <ion-icon class="headerIcon" size="large" slot="start" [src]="iconSrc"></ion-icon>

  <span class="item-type-container">
    <span class="item-type"
      ><span [class]="legendClass">{{ legend }}</span></span
      >
    </span>

    @if (isUnread()) {
      <span class="item-dot"></span>
    }

    <span class="item-date" [ngClass]="{ unread: isUnread() }">{{
      item.createdOn | amFromUtc | amLocal | amCalendar: null : formats
    }}</span>
  </div>
